import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { PageFrame } from '@/components/page-frame'
import { AuthenticationContextProvider } from "@/contexts/AuthenticationContext";
import { GenericAlert } from "@/components/generic-alert";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import * as React from "react";
import { users } from "@/api/api"
import { ElectricityConsumptionUnitContextProvider } from "@/energyPrices/ElectricityConsumptionUnitContext";
import { AggregateNormalizeContextProvider } from "@/installation/AggregateNormalizeContext";
import { FeedbackProvider } from "@/feedback/FeedbackContext";
import { FeedbackDialog } from "@/feedback/FeedbackDialog";
import { Spinner } from "@/components/ui/spinner";
import { isAuthenticated } from "@/auth";

const LoadingUserScreen = () => {
  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center gap-2">
      <Spinner/>
      Loading user details
    </div>
  );
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    // Check if user is authenticated
    const authenticated = isAuthenticated();

    if (!authenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(users.me())
  },
  pendingComponent: () => <LoadingUserScreen />,
  component: () => (
    <AuthenticationContextProvider>
      <FeedbackProvider>
        <ElectricityConsumptionUnitContextProvider>
          <AggregateNormalizeContextProvider>
            <PageFrame/>
            <FeedbackDialog/>
          </AggregateNormalizeContextProvider>
        </ElectricityConsumptionUnitContextProvider>
      </FeedbackProvider>
    </AuthenticationContextProvider>
  ),
  notFoundComponent: NotFoundComponent
})

function NotFoundComponent() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <GenericAlert>
        <p className="text-xl mb-4">
          Organization not found!
        </p>
        <Button>
          <Link to="/organization" className="flex flex-row gap-2 items-center">
            Go home
            <ChevronRight/>
          </Link>
        </Button>
      </GenericAlert>
    </div>
  )
}